import { useState, useEffect } from "react";

export const useNotificationToast = (
  id,
  removeNotification,
  duration = 5000,
) => {
  const [isHiding, setIsHiding] = useState(false);

  const handleRemove = () => {
    setIsHiding(true);
    setTimeout(() => removeNotification(id), 400);
  };

  useEffect(() => {
    const timer = setTimeout(() => handleRemove(), duration);
    return () => clearTimeout(timer);
  }, []);

  return { isHiding, handleRemove };
};
